/**
 * KeviaPriorityBanner — FASE 22
 *
 * Passive notification strip that surfaces urgent workflow state.
 * Non-modal, dismissible, never proposes confirmation.
 */

import { AlertTriangle, Info, X } from "lucide-react";
import { useState } from "react";

const LEVEL_STYLES = {
  urgent: {
    wrapper: "bg-red-50 border-red-200/60",
    icon:    <AlertTriangle size={14} className="text-red-500 shrink-0" />,
    text:    "text-red-700",
    dismiss: "text-red-400 hover:text-red-600",
  },
  attention: {
    wrapper: "bg-amber-50 border-amber-200/60",
    icon:    <AlertTriangle size={14} className="text-amber-500 shrink-0" />,
    text:    "text-amber-700",
    dismiss: "text-amber-400 hover:text-amber-600",
  },
  info: {
    wrapper: "bg-blue-50 border-blue-200/60",
    icon:    <Info size={14} className="text-blue-500 shrink-0" />,
    text:    "text-blue-700",
    dismiss: "text-blue-300 hover:text-blue-500",
  },
};

export default function KeviaPriorityBanner({ banner, onDismiss = null }) {
  const [dismissed, setDismissed] = useState(false);

  if (!banner || dismissed) return null;

  const styles = LEVEL_STYLES[banner.level] ?? LEVEL_STYLES.info;

  function handleDismiss() {
    setDismissed(true);
    onDismiss?.();
  }

  return (
    <div className={`flex items-center gap-2.5 px-3.5 py-2.5 rounded-[14px] border ${styles.wrapper} animate-fade`}>
      {styles.icon}
      <p className={`flex-1 text-[12px] font-medium leading-snug ${styles.text}`}>
        {banner.text}
      </p>
      <button
        onClick={handleDismiss}
        className={`shrink-0 transition-colors duration-150 ${styles.dismiss}`}
        aria-label="Cerrar"
      >
        <X size={13} />
      </button>
    </div>
  );
}
